export const FeatureGimmickEvent = {
  NotificationCenterNewFeatureUpdateImpression: 'notification_center_new_feature_update_impression',
  NotificationCenterNewFeatureUpdateClick: 'notification_center_new_feature_update_click',

  FeatureIntroModalView: 'feature_intro_modal_view',
  FeatureIntroModalCtaClick: 'feature_intro_modal_cta_click',
  FeatureIntroModalSeeMoreClick: 'feature_intro_modal_see_more_click',
  FeatureIntroModalClose: 'feature_intro_modal_close',

  FeatureUpdatesView: 'feature_updates_view',
  FeatureUpdatesItemImpression: 'feature_updates_item_impression',
  FeatureUpdatesItemClick: 'feature_updates_item_click',
} as const;

export type FeatureGimmickEventType = typeof FeatureGimmickEvent;

export interface FeatureGimmickEventDataType {
  [FeatureGimmickEvent.NotificationCenterNewFeatureUpdateImpression]: {
    feature_update_count: number;
  };
  [FeatureGimmickEvent.NotificationCenterNewFeatureUpdateClick]: {
    feature_update_count: number;
  };

  [FeatureGimmickEvent.FeatureIntroModalView]: {
    title: string;
    version_id: string;
  };
  [FeatureGimmickEvent.FeatureIntroModalCtaClick]: {
    title: string;
    version_id: string;
  };
  [FeatureGimmickEvent.FeatureIntroModalSeeMoreClick]: {
    title: string;
    version_id: string;
  };
  [FeatureGimmickEvent.FeatureIntroModalClose]: {
    title: string;
    version_id: string;
  };

  [FeatureGimmickEvent.FeatureUpdatesView]: {
    feature_update_count: number;
    campaign_ids: string[];
    campaign_titles: string[];
  };
  [FeatureGimmickEvent.FeatureUpdatesItemImpression]: {
    banner_title: string;
    campaign_name: string;
    list_order: number;
  };
  [FeatureGimmickEvent.FeatureUpdatesItemClick]: {
    banner_title: string;
    campaign_name: string;
    list_order: number;
  };
}
